<fl-autocomplete
  [placeholder]=""
  [inputControl]="fboId"
  [options]="options$ | async"
  [initialSelectedItem]="initialSelectedItem$ | async"
  (search)="onSearch($event)"
  [formatLabel]="formatNameLabel"
></fl-autocomplete>
